import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { BalancesEditModule } from '@modules/balances/submodules/edit/BalancesEditModule';
import { BalancesWithdrawalModule } from '@modules/balances/submodules/withdrawal/BalancesWithdrawalModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_BALANCES_LIST_ROUTE_NAME,
  ADMIN_BALANCES_ROUTE_NAME,
  BALANCES_PERMISSIONS,
  TRANSLATION_GROUP_BALANCES,
} from './constants';
import { getTranslationKeys } from './translations';

export class BalancesModule extends AppModule {
  protected submodules = [
    new BalancesEditModule(),
    new BalancesWithdrawalModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_BALANCES_ROUTE_NAME,
      path: 'partners-balances',
      permission: BALANCES_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'BalancesListPage',
    });

    router.addChildRoute(ADMIN_BALANCES_ROUTE_NAME, {
      name: ADMIN_BALANCES_LIST_ROUTE_NAME,
      path: '',
      permission: BALANCES_PERMISSIONS.SHOW,
      component: () => import('./pages/BalancesListPage/BalancesListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_PARTNERS_BALANCES'),
      to: {
        name: ADMIN_BALANCES_LIST_ROUTE_NAME,
      },
      permission: BALANCES_PERMISSIONS.SHOW,
      id: ADMIN_BALANCES_LIST_ROUTE_NAME,
      order: 120,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_BALANCES, getTranslationKeys);
  }
}
